import { KoobCard } from '@koob/ui';
import { useTranslation } from 'react-i18next';
import { HistoryItem } from './HistoryItem';

export const TripHistory = ({ histories }) => {
  const { t } = useTranslation('folders', { keyPrefix: 'tripHistory' });

  return (
    <KoobCard
      style={{ height: '36rem', overflow: 'auto', marginTop: '0.75rem' }}
    >
      {histories?.length === 0 ? (
        <div className="flex justify-center mt-6">
          <i
            className="fa-light fa-clock-rotate-left"
            style={{ fontSize: 30 }}
          />
          <h1 className="text-lg ml-2 tracking-wide">{t('emptyMessage')}</h1>
        </div>
      ) : (
        (histories ?? []).map(history => (
          <HistoryItem key={history?.id} history={history} />
        ))
      )}
    </KoobCard>
  );
};
